import { Component } from '@angular/core';

@Component({
  selector: 'app-features-page',
  templateUrl: './features-page.component.html',
  styleUrls: ['./features-page.component.scss']
})
export class FeaturesPageComponent {
  items = [
    { icon: 'star', title: 'Destaques', route: '/home/features/highlights' },
    { icon: 'warning', title: 'Avisos do sistema', route: '/home/features/system-broadcasts' }
  ];
}
